<template>
  <div class="screen-tab-filter-control">
    <div class="label">{{ label }}</div>
    <slot>Default Slot</slot>
  </div>
</template>

<script>
export default {
  name: 'ScreenTabFilterControl',
  props: {
    label: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/styles.sass';

.screen-tab-filter-control {
  display: grid;
  gap: 8px;

  .label {
    font-size: 14px;
    font-weight: 700;
    color: map-get($grey, 'darken-2');
  }
}
</style>
